import { useQuery } from '@tanstack/react-query';
import { getEmployeeWorkDayMinutes } from '@/api/leave-management';

export function useEmployeeWorkDayMinutes(
  companyId: string | null | undefined,
  employeeId: string | null | undefined,
) {
  return useQuery({
    queryKey: ['employee-work-day-minutes', companyId, employeeId],
    queryFn: () => getEmployeeWorkDayMinutes(companyId!, employeeId!),
    enabled: !!companyId && !!employeeId,
    select: (res) => res.data,
  });
}
